// extracted by mini-css-extract-plugin
export default {"swatch":"ColorPicker_swatch__2cT9X","color":"ColorPicker_color__0PPUs","onTop":"ColorPicker_onTop__xqqOT"};